// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import {
  getAuth,
  createUserWithEmailAndPassword,
  updateProfile,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDSig_dDdCHTA-70K5f1EMN0j6ta4pXPyI",
  authDomain: "nitinmomaya-primecinema.firebaseapp.com",
  projectId: "nitinmomaya-primecinema",
  storageBucket: "nitinmomaya-primecinema.appspot.com",
  messagingSenderId: "1040655053226",
  appId: "1:1040655053226:web:0e2a3e5d7a75ba0c7fbbd3",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// your firebase config here

//init firebase app
initializeApp(firebaseConfig);

//init services
const auth = getAuth();

export {
  auth,
  createUserWithEmailAndPassword,
  updateProfile,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  signInWithPopup,
  GoogleAuthProvider,
};

export default app;
